import PropTypes from 'prop-types';
import React from 'react';
import { ContextConfigProvider } from './ConfigContext';

class ConfigProvider extends React.PureComponent {
    static propTypes = {
        children: PropTypes.any,
        source: PropTypes.object.isRequired
    };

    constructor() {
        super();
        this.get = this.get.bind(this);
    }

    get() {
        return [...arguments].reduce((value, key) => {
            return value ? value[key] : undefined;
        }, this.props.source);
    }

    render() {
        const value = {
            get: this.get
        };

        return (
            <ContextConfigProvider value={ value }>
                {this.props.children}
            </ContextConfigProvider>
        );
    }
}

export default ConfigProvider;
